import React from "react";
import PropTypes from "prop-types";
import {OperationContext} from "@morningtrain/react-resources";

class CatchError extends React.Component {

    static contextType = OperationContext;

    get operation() {
        return this.context;
    }

    constructor(props) {
        super(props);

        this.state = {
            errCode: null,
        };
    }

    componentDidMount() {
        this.operation.onError(error => {
            this.handleError(error);
        });
    }

    handleError(error) {
        if (error && error.response) {
            this.setState({errCode: error.response.status});
        }
    }

    shouldRender() {
        const {code, renderOnError} = this.props;
        const {errCode} = this.state;

        if (code && code === errCode) {
            return renderOnError;
        }

        return !renderOnError;
    }

    get errorContent() {
        const {errorContent} = this.props;

        if (!errorContent) return null;

        if (typeof errorContent === 'function') return errorContent();

        return errorContent;
    }

    renderError() {
        return this.errorContent;
    }

    render() {
        return this.shouldRender() ?
            this.props.children :
            this.renderError();
    }

}

CatchError.propTypes = {
    code: PropTypes.number.isRequired, // Err code
    renderOnError: PropTypes.bool, // Use to invert when content is rendered
    errorContent: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.func,
    ]),
};

CatchError.defaultProps = {
    renderOnError: false,
};

export default CatchError;
